import React from 'react';
import PropTypes from 'prop-types';
import { routes } from 'app/constants';
import LinkButton from 'app/shared/navigation/LinkButton';

export default function PipelineNameCell({ row }) {
  const { pipeline } = row;
  const linkProps = {
    to: {
      pathname: routes.pipelineDetails,
      state: { pipelineId: pipeline.id },
    },
  };

  return (
    <LinkButton variant="text" color="secondary" data-test-id="pipeline-name-link" {...linkProps}>
      {pipeline.name}
    </LinkButton>
  );
}

PipelineNameCell.propTypes = {
  row: PropTypes.shape({
    pipeline: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
};
